//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import constant from '~/const';
import tableConfig from './tableConfig';

export default {
  data() {
    return {
      constant,
      tableConfig,
      dummyHints: false,
      aligments: {
        0: 'start',
        1: 'center',
        2: 'end',
      },
      textAlignements: {
        0: 'left',
        1: 'center',
        2: 'right',
      },
      testField: [
        {
          name: 'Final Check',
          fields: [
            {
              required: true,
              type: 'headline',
              align: 1,
              property: 'Identification title',
              value: 'Identification',
            },
            {
              required: false,
              property: 'Check type',
              value: '{check-type}',
            },
            {
              required: false,
              property: 'ATM-Number',
              value: '{atm-number}',
            },
            {
              required: false,
              property: 'Check number',
              value: '{check-number}',
            },
          ],
        },
      ],
      model: {
        name: '',
        property: '',
        value: '',
        type: '',
        align: 0,
      },
      currentField: '',
      fields: [],
    };
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.loadDataAction(),
    ]);
    this.setGeneralLoader(false);
  },

  computed: {
    ...mapState('common', {
      loader: (state) => state.generalLoader,
    }),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('cryptomatsChecks', ['page', 'pages', 'filters', 'data']),

    isApplyPossible() {
      return this.model.property && this.model.value;
    },
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('cryptomatsChecks', {
      loadDataAction: 'loadData',
      updateCheckAction: 'updateCheck',
    }),

    async loadData(data = {}) {
      this.setGeneralProgress(true);
      await this.loadDataAction(data);
      this.setGeneralProgress(false);
    },

    copy(text) {
      navigator.clipboard.writeText(`{{${text}}}`);
      this.setSuccessNotification('Copied to clipboard');
    },

    async deleteField(field) {
      this.confirmAction({
        title: 'Delete field',
        text: 'Are you sure, you want to delete this field?',
        callback: async () => {
          this.fields.splice(this.fields.indexOf(field), 1);

          const last = this.fields[this.fields.length - 1];
          this.currentField = last;
          this.model = last;
        },
      });
    },

    async saveCheck() {
      const payload = {
        name: this.model.name,
        fields: this.fields,
      };

      try {
        this.setGeneralProgress(true);
        await this.updateCheckAction(payload);
        this.setErrorNotification('You have successfully saved check');
      } catch (error) {
        this.setErrorNotification('Unable to save check');
      } finally {
        this.setGeneralProgress(false);
      }
    },

    addField() {
      const empty = {
        property: 'New field',
        value: 'New field value',
        name: this.model.name,
        required: false,
      };
      this.fields.push(empty);

      const last = this.fields[this.fields.length - 1];
      this.currentField = last;
      this.model = last;
    },

    changeField(field) {
      this.currentField = field;
      this.model = field;
    },

    handleCheckClick(row) {
      const first = row.fields[0];

      this.fields = row.fields;
      this.currentField = first;
      this.model = first;
      this.model.name = row.name;
    },

    applyFilters() {
      const { page } = this;
      if (page > 1) {
        this.setPageAction(1);
        this.$router.replace({ query: {} });
      }

      this.loadData();
    },

    setPage(value) {
      this.setPageAction(value);

      const extendedRequestData = {
        getTotal: false,
      };

      this.loadData(extendedRequestData);
    },
  },
};
